export enum FallEmergence {
  ALONE = 'ALONE',
  COMPANY = 'COMPANY',
}
